import { useSelector } from "react-redux";
import { IonLoading } from "@ionic/react";
import { selectLocationFetchStatus } from "../../../store/locationShow/selectors/selectLocationFetchStatus";
export const LoadingSection: React.FC = () => {
  const fetchStatus = useSelector(selectLocationFetchStatus);
  return (
    <>
      <IonLoading isOpen={fetchStatus === "pending"} message={"Cargando..."} />
    </>
  );
};
